import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getPaymentVoucher,
  getPaymentVoucherById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createPaymentVoucher,
  updatePaymentVoucher,
  approvePaymentVoucher,
} from "./thunk";

const initialState = {
  paymentVouchers: [],
  edit: false,
  paymentVoucher: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPaymentVoucher: false,
  loadingNext: false,
  loadingDetails: false,
  saveAndContinue: false,
  loadingApprove: false,
  paymentVoucherDetails: [
    {
      account: null,
      drAmount: "",
      crAmount: "",
      checkNo: "",
      costCenterDetail: "",
      unique: uuidv4(),
    },
  ],
  showCreateModal: false,
};

export const paymentVoucherSlice = createSlice({
  name: "paymentVoucher",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    paymentVoucherDetailsUpdated: (state, action) => {
      state.paymentVoucherDetails = action.payload;
    },
    clearPaymentVoucherDetails: (state) => {
      state.paymentVoucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
    clearAllPaymentVoucher: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPaymentVoucher = false;
      state.paymentVoucher = null;
      state.saveAndContinue = false;
      state.paymentVoucherDetails = [
        {
          account: null,
          drAmount: "",
          crAmount: "",
          checkNo: "",
          costCenterDetail: "",
          unique: uuidv4(),
        },
      ];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPaymentVoucher.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createPaymentVoucher.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createPaymentVoucher.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePaymentVoucher.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updatePaymentVoucher.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.paymentVoucher = action.payload.data;
      state.paymentVoucherDetails = action.payload.data?.paymentVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(updatePaymentVoucher.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(approvePaymentVoucher.pending, (state) => {
      state.loadingApprove = true;
    });
    builder.addCase(approvePaymentVoucher.fulfilled, (state, action) => {
      state.loadingApprove = false;
      state.paymentVoucher = action.payload.data;
      state.paymentVoucherDetails = action.payload.data?.paymentVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(approvePaymentVoucher.rejected, (state) => {
      state.loadingApprove = false;
    });
    // getPaymentVoucherById
    builder.addCase(getPaymentVoucherById.pending, (state) => {
      state.loading = true;
      state.paymentVoucher = null;
    });
    builder.addCase(getPaymentVoucherById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.paymentVoucher = action.payload.data;
      state.paymentVoucherDetails = action.payload.data?.paymentVoucherDetails?.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getPaymentVoucherById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
    });
    builder.addMatcher(
      isAnyOf(
        getPaymentVoucher.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPaymentVoucher = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPaymentVoucher.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPaymentVoucher = false;
        state.paymentVouchers = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPaymentVoucher.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPaymentVoucher = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  paymentVoucherDetailsUpdated,
  clearPaymentVoucherDetails,
  clearAllPaymentVoucher,
} = paymentVoucherSlice.actions;

export default paymentVoucherSlice.reducer;
